import CricutLogo from "../assets/brand-logos/cricut-logo.png";
import DtfTransfersLogo from "../assets/brand-logos/dtftransfers-logo.png";
import HillelLogo from "../assets/brand-logos/hillel-brand-logo.png";
import InfluxerLogo from "../assets/brand-logos/influxer-logo.png";
import MakerfloLogo from "../assets/brand-logos/makerflo-logo.png";
import MerchDayLogo from "../assets/brand-logos/merchday-brand-logo.png";
import NinjaCustomsLogo from "../assets/brand-logos/ninjacustoms-logo.png";
import NinjaOnDemandLogo from "../assets/brand-logos/ninjaondemand-logo.png";
import NinjaPodLogo from "../assets/brand-logos/ninjapod-logo.png";
import NinjaPrinthouseLogo from "../assets/brand-logos/ninjaprinthouse-logo.png";
import NinjaTransfersLogo from "../assets/brand-logos/ninjatransfers-logo.png";
import PrintflyOneLogo from "../assets/brand-logos/printflyone-brand-logo.png";
import RushOrderTeesLogo from "../assets/brand-logos/rushordertees-logo.png";
import RyonetLogo from "../assets/brand-logos/ryonet-logo.png";
import SSActivewearPodLogo from "../assets/brand-logos/ssactivewear-logo.png";
import SouthBySeaLogo from "../assets/brand-logos/southbysea-logo.png";
import WhiteCricutLogo from "../assets/brand-logos/cricut-logo_white.png";
import WhiteDtfTransfersLogo from "../assets/brand-logos/dtftransfers-logo_white.png";
import WhiteInfluxerLogo from "../assets/brand-logos/influxer-logo_white.png";
import WhiteMakerfloLogo from "../assets/brand-logos/makerflo-logo_white.png";
import WhiteNinjaCustomsLogo from "../assets/brand-logos/ninjacustoms-logo_white.png";
import WhiteNinjaOnDemandLogo from "../assets/brand-logos/ninjaondemand-logo_white.png";
import WhiteNinjaPodLogo from "../assets/brand-logos/ninjapod-logo_white.png";
import WhiteNinjaPrinthouseLogo from "../assets/brand-logos/ninjaprinthouse-logo_white.png";
import WhiteNinjaTransfersLogo from "../assets/brand-logos/ninjatransfers-logo_white.png";
import WhiteRushOrderTeesLogo from "../assets/brand-logos/rushordertees_logo_white.png";
import WhiteRyonetLogo from "../assets/brand-logos/ryonet-logo.png";
import WhiteSSActivewearPodLogo from "../assets/brand-logos/ssactivewear-logo_white.png";
import WhiteSouthBySeaLogo from "../assets/brand-logos/south-by-sea-white.png";

const getLogoForBrandUrl = (brandUrl, theme) => {
  switch (brandUrl) {
    case "cricut.com":
      switch (theme) {
        case "light":
          return CricutLogo;
        case "dark":
          return WhiteCricutLogo;
        default:
          return CricutLogo;
      }
    case "dtftransfers.com":
      switch (theme) {
        case "light":
          return DtfTransfersLogo;
        case "dark":
          return WhiteDtfTransfersLogo;
        default:
          return DtfTransfersLogo;
      }
    case "hillel.college.ink":
      return HillelLogo;
    case "influxermerch.com":
      switch (theme) {
        case "light":
          return InfluxerLogo;
        case "dark":
          return WhiteInfluxerLogo;
        default:
          return InfluxerLogo;
      }
    case "makerflo.com":
      switch (theme) {
        case "light":
          return MakerfloLogo;
        case "dark":
          return WhiteMakerfloLogo;
        default:
          return MakerfloLogo;
      }
    case "merchday.com":
      return MerchDayLogo;
    case "printflyone.com":
      return PrintflyOneLogo;
    case "rushordertees.com":
      switch (theme) {
        case "light":
          return RushOrderTeesLogo;
        case "dark":
          return WhiteRushOrderTeesLogo;
        default:
          return RushOrderTeesLogo;
      }
    case "southbysea.com":
      switch (theme) {
        case "light":
          return SouthBySeaLogo;
        case "dark":
          return WhiteSouthBySeaLogo;
        default:
          return SouthBySeaLogo;
      }
    case "ninjacustom.com":
      switch (theme) {
        case "light":
          return NinjaCustomsLogo;
        case "dark":
          return WhiteNinjaCustomsLogo;
        default:
          return NinjaCustomsLogo;
      }
    case "ninjaprinthouse.com":
      switch (theme) {
        case "light":
          return NinjaPrinthouseLogo;
        case "dark":
          return WhiteNinjaPrinthouseLogo;
        default:
          return NinjaPrinthouseLogo;
      }
    case "ninjapod.com":
      switch (theme) {
        case "light":
          return NinjaPodLogo;
        case "dark":
          return WhiteNinjaPodLogo;
        default:
          return NinjaPodLogo;
      }
    case "ninjaondemand.com":
      switch (theme) {
        case "light":
          return NinjaOnDemandLogo;
        case "dark":
          return WhiteNinjaOnDemandLogo;
        default:
          return NinjaOnDemandLogo;
      }
    case "ninjatransfers.com":
      switch (theme) {
        case "light":
          return NinjaTransfersLogo;
        case "dark":
          return WhiteNinjaTransfersLogo;
        default:
          return NinjaTransfersLogo;
      }
    case "ssactivewear.com":
      switch (theme) {
        case "light":
          return SSActivewearPodLogo;
        case "dark":
          return WhiteSSActivewearPodLogo;
        default:
          return SSActivewearPodLogo;
      }
    case "ryonet.com":
      switch (theme) {
        case "light":
          return RyonetLogo;
        case "dark":
          return WhiteRyonetLogo;
        default:
          return RyonetLogo;
      }
    default:
      return null;
  }
};

export { getLogoForBrandUrl };
